import Http from "@/commons/Http";
import Utils from "@/commons/Utils.js";

const path = 'api/tipo-documento';

// Cache de módulo do catálogo de espécies: é lista fechada da VHL, não muda dentro da sessão.
let especies = null;
let variaveisGerais = null;

export default {

  async getAll(resetCache = ''){
    return Http.get(`${path}${resetCache ? '?reset=' + resetCache : ''}`);
  },

  async getAllSimpleList() {
    return Http.get(`${path}/all-simple`);
  },

  async getSimpleList(){
    return Http.get(`${path}/simple`);
  },

  async getSimpleListIds(ids){
    return Http.post(`${path}/simple`, ids);
  },

  async getSimpleListAssignmentIds(atribuicao, ids){
    return Http.post(`${path}/${atribuicao}/simple`, ids);
  },

  async getById(id){
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}`);
  },

  async save(dto, id = ''){
    return Http.post(`${path}/${id}`, dto);
  },

  async getListaDocumento(){
    return Http.get(`${path}/lista-documento`);
  },

  /**
   * Catálogo das espécies documentais com os campos padrão de cada uma.
   * Alimenta o select do cadastro e o card "Dados do Documento" do editor.
   *
   * Cacheado no módulo: é lista fechada da VHL, não muda dentro da sessão.
   */
  async getEspecies(){
    if(!especies){
      especies = Http.get(`${path}/especies`).catch(e => { especies = null; return Promise.reject(e); });
    }
    return especies;
  },

  /**
   * As variáveis de minuta do documento que não pertencem a espécie nenhuma — título, tipo e
   * espécie do próprio documento.
   *
   * Endpoint à parte do de espécies porque a lista não depende da espécie escolhida: vale em todas,
   * inclusive nos tipos que ainda não têm espécie. Cacheada pelo mesmo motivo: é lista fechada.
   */
  async getVariaveisGerais(){
    if(!variaveisGerais){
      variaveisGerais = Http.get(`${path}/variaveis-gerais`).catch(e => { variaveisGerais = null; return Promise.reject(e); });
    }
    return variaveisGerais;
  },

  /** Os grupos de campos de uma espécie, ou vazio se ela não tem espécie. */
  async getCamposEspecie(especie){
    if(!especie) return [];
    const lista = await this.getEspecies().catch(() => []);
    return (lista || []).find(e => e.id === especie)?.grupos || [];
  },
}
